import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { useContext } from "react";
import { LoadPagePanel } from "../../../../components";
import { CompanyTypes, KindOfOrder } from "../../../../types/enums";
import { showErrorMessage } from "../../../../utils/messages";
import NoteGrid from "../../../common/notes/components/NoteGrid";
import { useMarkCFINoteAsRead } from "../../notes/api/mark-cfi-note-as-read";
import { RefetchScope, RetailOrderContext } from "../context/RetailOrderContext";
import RetailOrderAddNoteButton from "./RetailOrderAddNoteButton";

export default function RetailOrderNotes() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const markNoteAsRead = useMarkCFINoteAsRead(
		() => { refetchOrder(RefetchScope.Notes) },
		(error) => showErrorMessage(error));

	return (
		<>
			<Toolbar className='button-toolbar note-button-toolbar'>
				<Item location={'before'}>
					<RetailOrderAddNoteButton />
				</Item>
				<Item location={'after'}>
					{
						order.details.notes.find(x => x.createdByCompanyTypeID === CompanyTypes.CFI && !x.readOn) &&
						<Button
							text="Mark All As Read"
							icon="Inscyth-Order-Material"
							disabled={markNoteAsRead.isLoading}
							onClick={() => {
								markNoteAsRead.mutate({ orderID: order.details.retailOrderID, kindOfOrder: KindOfOrder.RetailOrder });
							}}>
						</Button>
					}
				</Item>
			</Toolbar>
			<NoteGrid
				notes={order.details.notes}
				showMarkAsReadCompanyTypeID={CompanyTypes.CFI}
				onMarkNoteAsRead={(noteID: number) => {
					markNoteAsRead.mutate({ noteID: noteID });
				}}
			/>
			<LoadPagePanel visible={markNoteAsRead.isLoading}></LoadPagePanel>
		</>
	)
}
